module.exports = __webpack_public_path__ + "img/logo38.ff035ae2.png";